module.exports = __webpack_public_path__ + "img/add-other-arrange-table-icon.fd0d88e8.svg";